import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { AthleteEnergyExpenditureHistoryQuery } from "../../../../types";

interface HistoricalTableSourceRowProps {
  entry: AthleteEnergyExpenditureHistoryQuery["athleteEnergyExpenditureHistory"]["edges"][0];
}

export const HistoricalTableSourceRow: React.FC<HistoricalTableSourceRowProps> = ({
  entry,
}) => {
  const cellStyle = {
    fontSize: 14,
    color: "#101828",
    borderBottom: "1px solid #eaecf0",
    py: 1.5,
  };

  return (
    <TableRow hover>
      {/* Empty cell for date column (indented) */}
      <TableCell sx={{ ...cellStyle, pl: 6 }} />

      <TableCell sx={cellStyle}>{entry.source}</TableCell>
      <TableCell sx={cellStyle}>—</TableCell>
      <TableCell sx={cellStyle} align="right">
        {entry.tdee != null ? `${Math.round(entry.tdee).toLocaleString()} kcal` : "—"}
      </TableCell>
      <TableCell sx={cellStyle} align="right">
        {entry.activeEnergy != null ? `${Math.round(entry.activeEnergy).toLocaleString()} kcal` : "—"}
      </TableCell>
      <TableCell sx={cellStyle} align="right">
        {entry.restingEnergy != null ? `${Math.round(entry.restingEnergy).toLocaleString()} kcal` : "—"}
      </TableCell>
      <TableCell sx={cellStyle} align="right">
        —
      </TableCell>
      <TableCell sx={cellStyle} align="right">
        —
      </TableCell>
      <TableCell sx={cellStyle} align="right">
        —
      </TableCell>
    </TableRow>
  );
};
